<app-auth-drawer heading="create your account" description="create account description" (closed)="close()">
  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate class="flex flex-col gap-5!">
    <div class="flex flex-col gap-2!">
      <label for="rg-name" class="auth-label">{{ 'name' | translate }} <span aria-hidden="true" class="auth-required">*</span></label>
      <input id="rg-name"
             type="text"
             autocomplete="name"
             formControlName="name"
             cdkFocusInitial
             class="auth-input"
             [class.auth-input-invalid]="isInvalid('name')"
             [attr.aria-invalid]="isInvalid('name')"
             [placeholder]="'first and last name' | translate"/>
      @if (isInvalid('name')) {
        <p class="auth-error"><mat-icon class="auth-error-icon" aria-hidden="true">error_outline</mat-icon>{{ 'name required' | translate }}</p>
      }
    </div>

    <div class="flex flex-col gap-2!">
      <label for="rg-email" class="auth-label">{{ 'email' | translate }} <span aria-hidden="true" class="auth-required">*</span></label>
      <input id="rg-email"
             type="email"
             autocomplete="email"
             formControlName="email"
             class="auth-input"
             [class.auth-input-invalid]="isInvalid('email')"
             [attr.aria-invalid]="isInvalid('email')"
             [placeholder]="'enter your email address' | translate"/>
      @if (isInvalid('email')) {
        <p class="auth-error"><mat-icon class="auth-error-icon" aria-hidden="true">error_outline</mat-icon>{{ (hasError('email', 'required') ? 'email required' : 'email invalid') | translate }}</p>
      }
    </div>

    <div class="flex flex-col gap-3! pt-1!">
      <button type="submit" class="auth-btn auth-btn-primary" [disabled]="spinLoader" [attr.aria-busy]="spinLoader">
        @if (spinLoader) {
          <span class="loading-container"><mat-icon>hourglass_empty</mat-icon></span>
        }
        {{ 'create account' | translate }}
      </button>
      <button type="button" class="auth-btn auth-btn-secondary" (click)="close()">{{ 'cancel' | translate }}</button>
    </div>
  </form>
</app-auth-drawer>
